export enum FieldConfigType {
    Text = 'text',
    Checkbox = 'checkbox',
    RadioGroup = 'radio-group',
    SingleSelect = 'single-select',
    MultiSelect = 'multi-select',
    MultiLineText = 'multi-line-text',
    Date = 'date',
    Time = 'time',
    DateTime = 'datetime',
    Address = 'address',
    Numerical = 'numerical',
    ObjectArray = 'object-array',
    SearchableSelect = 'searchable-select',
    Html = 'html',
    CustomItemTemplate = 'custom-item-template'
}